import dashboardRouter from '@/router/dashboardRouter.js'
import accountRouter from '@/router/accountRouter.js'
import roleRouter from '@/router/roleRouter.js'
import intakeRouter from '@/router/intakeRouter.js'
import healthRecordRouter from '@/router/healthRecordRouter.js'
import speciesRouter from '@/router/speciesRouter.js'
import parameterRouter from '@/router/parameterRouter.js'
import releaseInWildRouter from '@/router/releaseInWildRouter.js'
import testReportRouter from '@/router/testReportRouter.js'
import typeFormsRouter from '@/router/typeFormsRouter.js'
import dissectReportRouter from '@/router/dissectReportRouter.js'
import testManagerRouter from '@/router/testManagerRouter.js'
import taskRouter from '@/router/taskRouter.js'
import inStockRouter from '@/router/inStockRouter.js'
import releaseFormsRouter from '@/router/releaseFormsRouter.js'
import typeSurveyRouter from '@/router/typeSurveyRouter.js'
import scheduleRouter from '@/router/scheduleRouter.js'
import vendorRouter from '@/router/vendorRouter.js'
//xxxxx:8081/dashboard
const mainLayoutRouter = [
    {
        path:'',
        name:'main',
        redirect: { name: 'dashboard-overview' },
    },
    {
        path:'dashboard',
        name:'dashboard',
        children:dashboardRouter
    },
    {
        path:'account',
        name:'account',
        children:accountRouter
    },
    {
        path:'role',
        name:'role',
        children:roleRouter
    },
    {
        path:'intake',
        name:'intake',
        children:intakeRouter
    },
    {
        path:'healthRecord',
        name:'healthRecord',
        children:healthRecordRouter
    },
    {
        path:'species',
        name:'species',
        children:speciesRouter
    },
    {
        path:'parameter',
        name:'parameter',
        children:parameterRouter
    },
    {
        path:'releaseInWild',
        name:'releaseInWild',
        children:releaseInWildRouter
    },
    {
        path:'testReports',
        name:'testReports',
        children:testReportRouter
    },
    {
        path:'typeForms',
        name:'typeForms',
        children:typeFormsRouter
    },
    {
        path:'typeSurvey',
        name:'typeSurvey',
        children:typeSurveyRouter
    },
    {
        path:'releaseForms',
        name:'releaseForms',
        children:releaseFormsRouter
    },
    { 
        path:'dissectReport',
        name:'dissectReport',
        children:dissectReportRouter
    },
    { 
        path:'testManager',
        name:'testManager',
        children:testManagerRouter
    },
    { 
        path:'task',
        name:'task',
        children:taskRouter
    },
    {
        path:'inStock',
        name:'inStock',
        children:inStockRouter
    },
    {
        path:'schedule',
        name:'schedule',
        children:scheduleRouter
    },
    {
        path:'vendor',
        name:'vendor',
        children:vendorRouter
    },{
        path:'resetPassword',
        name:'resetPassword',
        component: () => import(/* webpackChunkName: "about" */ '../views/resetPassword.vue')
    }
  ]
  export default mainLayoutRouter